export default "__VITE_ASSET__07c68cb6__"